import React, { useState, useEffect } from 'react';

export default function TagManager({ selectedImages = [], onClose }) {
  const [tags, setTags] = useState([]);
  const [newTag, setNewTag] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTags();
  }, []);

  async function fetchTags() {
    const res = await fetch('/api/tags', { credentials: 'include' });
    const data = await res.json();
    setTags(data);
  }

  async function createTag() {
    if (!newTag.trim()) return;
    
    const res = await fetch('/api/tags', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ label: newTag.trim() })
    });
    
    if (res.ok) {
      const tag = await res.json();
      setTags(prev => [...prev, tag].sort((a, b) => a.label.localeCompare(b.label)));
      setNewTag('');
    }
  }

  async function applyTags() {
    if (selectedTags.length === 0 || selectedImages.length === 0) return;
    
    setLoading(true);
    try {
      await fetch('/api/tags/apply', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          image_ids: selectedImages,
          tag_ids: selectedTags
        })
      });
      
      if (onClose) onClose();
    } finally {
      setLoading(false);
    }
  }

  function toggleTag(tagId) {
    setSelectedTags(prev => 
      prev.includes(tagId) 
        ? prev.filter(id => id !== tagId)
        : [...prev, tagId]
    );
  }

  return (
    <div className="tag-manager">
      <div className="tag-manager-header">
        <h3>Manage Tags</h3>
        {selectedImages.length > 0 && (
          <span className="muted">{selectedImages.length} images selected</span>
        )}
      </div>
      
      <div className="tag-create">
        <input
          type="text"
          placeholder="Create new tag..."
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && createTag()}
        />
        <button onClick={createTag} disabled={!newTag.trim()}>
          Add Tag
        </button>
      </div>
      
      <div className="tag-list">
        {tags.map(tag => (
          <div
            key={tag.id}
            className={`tag-chip ${selectedTags.includes(tag.id) ? 'selected' : ''}`}
            onClick={() => toggleTag(tag.id)}
          >
            <span>{tag.label}</span>
            {tag.usage_count > 0 && (
              <span className="tag-count">{tag.usage_count}</span>
            )}
          </div>
        ))}
      </div>
      
      {selectedImages.length > 0 && (
        <div className="tag-actions">
          <button onClick={onClose} className="button-secondary">
            Cancel
          </button>
          <button 
            onClick={applyTags} 
            disabled={selectedTags.length === 0 || loading}
            className="button-primary"
          >
            {loading ? 'Applying...' : `Apply ${selectedTags.length} Tag${selectedTags.length !== 1 ? 's' : ''}`}
          </button>
        </div>
      )}
    </div>
  );
}